import {
  EnrollmentStatus,
  IEnrollment
} from "@wingspanhq/benefits/dist/src/lib/interfaces/enrollment";

export interface SelectorShouldShowMemberAndGroupInfoInput {
  sidebarHideMemberIds?: boolean;
  enrollment?: IEnrollment;
}

// Hide the IDs only on an explicit terminal/inactive state: the benefit's own
// sidebarHideMemberIds flag, or the enrollment explicitly Paused/Disabled. A
// missing enrollment status does NOT hide, so legacy enrollment records are
// unaffected.
export const selectorShouldShowMemberAndGroupInfo = ({
  sidebarHideMemberIds,
  enrollment
}: SelectorShouldShowMemberAndGroupInfoInput): boolean => {
  const enrollmentStatus = enrollment?.wingspanBenefits?.status;
  const isEnrollmentExplicitlyInactive =
    enrollmentStatus === EnrollmentStatus.Paused ||
    enrollmentStatus === EnrollmentStatus.Disabled;

  return !sidebarHideMemberIds && !isEnrollmentExplicitlyInactive;
};
